interface InfoCardItem {
  cdProvideType?: string;
  productName: string;
  active: boolean;
  select: boolean;
  // 이전 API 호환성을 위한 필드
  name?: string;
  available?: boolean;
}

interface InfoCardProps {
  title: string;
  items: InfoCardItem[] | null | undefined;
  icon: React.ReactNode;
}

export const InfoCard = ({ title, items, icon }: InfoCardProps) => {
  if (!items || items.length === 0) {
    return null;
  }

  // active하고 select된 항목만 필터링 (또는 이전 API 형식의 available 항목)
  const availableItems = items.filter(
    (item) =>
      (item.active && item.select) ||
      (item.available !== undefined && item.available)
  );

  if (availableItems.length === 0) {
    return null;
  }

  return (
    <div className="p-4 bg-white rounded-xl shadow-sm">
      <div className="flex gap-2 items-center mb-3">
        <div className="text-gray-600">{icon}</div>
        <h3 className="text-[17px] font-semibold text-gray-800">{title}</h3>
      </div>
      <div className="flex flex-wrap gap-2">
        {availableItems.map((item: InfoCardItem, index: number) => {
          // 새로운 API 형식의 productName 또는 이전 API 형식의 name 사용
          const displayName = item.productName || item.name || "";
          return (
            <div
              key={index}
              className="px-3 py-2 rounded-lg border bg-yellow/10 border-yellow/30"
            >
              <span className="text-sm font-medium text-yellow">
                {displayName}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

